module.exports = __webpack_public_path__ + "static/media/Dance Instructor.44544d19.jpg";